import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LesFormComponent } from './les-form/les-form.component';
import { LesReportComponent } from './les-report/les-report.component';
@NgModule({
  declarations: [LesFormComponent, LesReportComponent, ] ,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule],
  
  providers: []
})
export class LesModule { }
